import React from "react";
import styled from 'styled-components';
import { Card, Heading } from "../../Components/StyledComponents/StyledComponents";

const Root = styled.div`
margin:${(p) => p.theme.spacing.sm} 0;

`;

const Div = styled.div`
letter-spacing: 0.36px;
line-height: 2.56;
font-size:${(p) => p.theme.font.size.xs};
@media(min-width:1600px){
    font-size:${(p) => p.theme.font.size.sm};
}
`;
const ActionRules = ({ nft }) => {
    return (
        <Root>
            <Heading bottom="sm">
                Action Rules
            </Heading>
            <Card>
                <Div>
                    1. Each time you participate in the auction, you need to increase the price by 10%.
                    After the countdown ends, the auction item will be obtained by the last bidder.
                </Div>
                <Div>
                    2. 20% of this increase is obtained by the previous bidder, and 80% by the seller.
                </Div>
                <Div>
                    3. After the auction is successful, the market will charge 3% of the seller’s revenue as a
                    service fee, of which 50% is burned, 40% enters the Metaspace NFT Pool, and 10% is the developer’s revenue.
                </Div>
                <Div>
                    4. When the auction countdown is less than 1 hour, the auction end time will be extended by 10 minutes for every successful bid.
                </Div>
                <Div>
                    5. After the auction is over, the seller can go to the details page to claim the auction proceeds, and the buyer can claim the NFT.
                </Div>
            </Card>
        </Root>
    );
};

export default ActionRules;